import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";
import { Rollshop } from "./components/Rollshop";

export const RollshopPage = () => {
	return (
		<>
			<HelmetDexteel title="Rollshop" />
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "calc(100vh - 64px)",
					gap: 1,
					p: 1,
					bgcolor: "#f0f2f5",
				}}
			>
				<Typography variant="h5" sx={{ fontWeight: 600 }}>
					Rollshop
				</Typography>
				<Rollshop />
			</Box>
		</>
	);
};
